import { connect } from "react-redux";

import PlusBorderRounded from "@components/Icons/PlusBorderRounded";
import ArrowRight from "@components/Icons/ArrowRight";
import { addModal } from "@store/app/actions";
import ServiceTitle from "@components/ProductPage/ProductServices/ServiceTitle";
import { formatPrice } from "@lib/helpers";
import Close from "@components/Icons/Close";
import ExtraWarantyIcon from "@components/Icons/ProductPage/ExtraWarantyIcon";
import MobileProtectIcon from "@components/Icons/ProductPage/MobileProtectIcon";
import InstallIcon from "@components/Icons/ProductPage/InstallIcon";
import BYBIcon from "@components/Icons/ProductPage/BYBIcon";

const servicesIconsMap = {
  extra_warranty: <ExtraWarantyIcon />,
  mobile_protect: <MobileProtectIcon />,
  install: <InstallIcon />,
  buyback: <BYBIcon />,
};

const ProductServices = ({
  services,
  activeServices,
  addModal,
  removeService,
}) => (
  <div>
    <div
      className="border rounded p-[8px] flex space-x-[8px] cursor-pointer"
      onClick={() => addModal("productServicesModal")}
    >
      <div className="flex items-center gap-[4px]">
        <PlusBorderRounded width="16px" height="16px" />
        <span className="hidden sm:inline md:hidden lg:inline text-[14px]">
          Adauga
        </span>
      </div>

      <div className="flex flex-wrap gap-[8px] w-full">
        {Object.keys(services).map((serviceKey) => (
          <div
            key={serviceKey}
            className="px-[8px] py-[4px] rounded bg-[#FFEFC6] text-[14px] font-medium min-w-fit"
          >
            <ServiceTitle serviceKey={serviceKey} />
          </div>
        ))}
      </div>

      <div className="self-center">
        <ArrowRight />
      </div>
    </div>

    {activeServices && (
      <div className="mt-[8px] space-y-[8px]">
        {Object.entries(activeServices).map(
          ([key, { sku, additional_data }]) => {
            const activeServiceDetails = services[key].find(
              (serviceOption) => serviceOption.sku === sku
            );

            const { short_description, name, price } = activeServiceDetails;

            const hasActiveChildService =
              additional_data && additional_data.childSku;

            const childServiceDetails =
              hasActiveChildService &&
              activeServiceDetails.product_links[key].find(
                (serviceOption) =>
                  serviceOption.sku === additional_data.childSku
              );

            return (
              <div className="p-[8px] bg-[#FFF9EB] rounded" key={sku}>
                <div className="flex items-center justify-between">
                  {servicesIconsMap[key] && (
                    <span className="inline-block mr-[4px] self-start mt-[2px]">
                      {servicesIconsMap[key]}
                    </span>
                  )}

                  <div className="text-[14px] font-medium w-full">
                    <ServiceTitle serviceKey={key} />:
                    <span className="font-normal">
                      {" "}
                      {short_description ?? name}{" "}
                      {key !== "buyback" && `- ${formatPrice(price)} lei`}
                    </span>
                  </div>

                  <div
                    className="text-[#DC2626] p-[5px] cursor-pointer"
                    onClick={() => removeService({ key })}
                  >
                    <Close width={10} height={10} />
                  </div>
                </div>

                {hasActiveChildService && (
                  <div className="flex items-center justify-between ml-[20px] mt-[6px]">
                    <div className="text-[14px] font-medium border-t mr-[16px] pt-[6px] flex items-center flex-wrap gap-[4px]">
                      {childServiceDetails.name}:{" "}
                      <span className="font-normal inline">
                        {childServiceDetails.short_description ??
                          childServiceDetails.name}{" "}
                        - {formatPrice(childServiceDetails.price)} lei
                      </span>
                    </div>

                    <div
                      className="text-[#DC2626] p-[5px] cursor-pointer"
                      onClick={() => removeService({ key, child: true })}
                    >
                      <Close width={10} height={10} />
                    </div>
                  </div>
                )}
              </div>
            );
          }
        )}
      </div>
    )}
  </div>
);

export default connect(null, { addModal })(ProductServices);
